
document.addEventListener("DOMContentLoaded", function() {
  const helpLink = document.getElementById("compare-help-link");
  const popup = document.getElementById("compare-help-popup");
  const popupClose = document.getElementById("compare-popup-close");
  const metafieldContainer = document.getElementById("compare-metafield-content");

  let comparisonSwiper = null;

  function initSwiper() {
    if (!popup) return;

    if (window.innerWidth <= 768) {
      if (!comparisonSwiper) {
        comparisonSwiper = new Swiper('.comparison-swiper', {
          slidesPerView: 1,
          spaceBetween: 20,       // no gap between slides
          centeredSlides: true,  
          loop: false,
          grabCursor: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
         
          breakpoints: {
            480: {
              slidesPerView: 1,
              spaceBetween: 15,
            }
          },
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: true,
        });
      }
    } else {
      if (comparisonSwiper) {
        comparisonSwiper.destroy(true, true);
        comparisonSwiper = null;
      }
    }
  }

function openPopup() {
  if (!popup) return;

  const product_size = popup.querySelectorAll('.comparison-product').length;
  popup.style.setProperty('--product-count', product_size);

  popup.classList.add("active");
  document.body.style.overflow = "hidden";

  setTimeout(() => {
    initSwiper();
    if (comparisonSwiper) {
      comparisonSwiper.update();
    }
  }, 100);
}

function closePopup() {
  if (!popup) return;

  popup.classList.remove("active");
  document.body.style.overflow = "";
}

  if (helpLink) {
    helpLink.addEventListener("click", function(e) {
      e.preventDefault();
      openPopup();
    });
  }

  if (popupClose) {
    popupClose.addEventListener("click", closePopup);
  }

  if (popup) {
    popup.addEventListener("click", function(e) {
      if (e.target === popup) {
        closePopup();
      }
    });
  }

  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      closePopup();
    }
  });

  window.addEventListener('resize', function() {
    setTimeout(initSwiper, 100);
  });
});
